import { render } from "./GameOverview.vue?vue&type=template&id=64f015ca&ts=true"
import script from "./GameOverview.vue?vue&type=script&lang=ts"
export * from "./GameOverview.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__